import script from "./vmsSetupMFA.vue?vue&type=script&lang=js"
export * from "./vmsSetupMFA.vue?vue&type=script&lang=js"

import "./vmsSetupMFA.vue?vue&type=style&index=0&id=2cffaa21&lang=css"
import "./vmsSetupMFA.vue?vue&type=style&index=1&id=2cffaa21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cffaa21"]])

export default __exports__